import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { Component, ObjectManager } from '../../../concepts/objects';
import { Hand } from '../../packages/hand/Hand';
import { EditorSession } from '../EditorSession';
import { IsDeveloperMode } from './IsDeveloperMode';

export const developerGC = defineCommand(
    'developerGC',
    'Developer: Garbage Collect',
    (r) => {
        // Resolve dependencies
        const objects = r.call(ObjectManager);

        const all = objects.getAll();
        const initial = [] as Component[];

        for (const x of all) {
            if (x.id === 'root') continue;
            if (x.mounted()) continue;
            if (x.is(Hand)) continue;
            initial.push(x);
        }

        const targets = initial.flatMap(x => x.flatten(true)).reverse();
        if (!targets.length) return;

        objects.update(u => {
            for (const t of targets) {
                if (!t.alive) continue;
                if (t.parent) t.removeSelf();
                // eslint-disable-next-line no-console
                console.log('Deleting garbage', t.type, t.id);
                u.delete(t, 'cascade');
            }
        });
    },
);

export const developerToggle = defineCommand(
    'developerToggle',
    'Developer: Toggle',
    (r) => r.call(EditorSession).apply(IsDeveloperMode, value => !value)
);

export const inDeveloperCommands = () => inCommands(
    developerGC,
    developerToggle,
);
